import { createQueryKeys } from '@lukemorales/query-key-factory'
import { getNavigationMenu } from './http/get-navigation-menu.http'

export const NavigationQueryKeys = createQueryKeys('navigation', {
  menu: {
    queryKey: null,
    queryFn: ({ signal }) => getNavigationMenu({ signal }),
  },
})
